import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FormLabel, FormInput, Button, MetaInfo } from "../../../components/StyledElements";
import { Icon } from "@iconify/react";
import { ParticipantCard } from "../../../components/LiveEvent/ParticipantCard";
import { CollaboratorCard } from "../../../components/LiveEvent/CollaboratorCard";
import { useLiveEvents } from "../../../contexts/LiveEventsContext";
import { inviteCollaborator } from "../../../services/liveevents";
import { useAuthContext } from "../../../contexts/AuthContext";

export const PreviewSidebar = ({ style = {} }) => {
  console.log("!!! RENDERING PREVIEW SIDEBAR");
  const token = useSelector((state) => state.users.token);
  const { activeUser } = useAuthContext();
  const { updatedEvent, setUpdatedEvent } = useLiveEvents();
  const [inviteEmail, setInviteEmail] = useState();
  const [validEmail, setValidEmail] = useState(false);
  const [sendingInvite, setSendingInvite] = useState(false);
  const [allowChangeRole, setAllowChangeRole] = useState(true);
  const userCount = updatedEvent?.user_count ?? 0;
  const emailRef = useRef();

  useEffect(() => {
    const isHost = updatedEvent?.collaborators?.find((collaborator) => collaborator.user?.public_id === activeUser.public_id && (collaborator.role === "host" || collaborator.role === "owner" || collaborator.is_owner));
    setAllowChangeRole(!!isHost);
  }, [activeUser, updatedEvent]);

  useEffect(() => {
    if (inviteEmail) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setValidEmail(emailRegex.test(inviteEmail));
    } else {
      setValidEmail(false);
    }
  }, [inviteEmail]);

  return (
    <div style={style}>
      <div style={{
        display: "flex", flexDirection: "row", alignItems: "center", gap: "10px"
      }} >
        <Icon icon="mdi:account-multiple-plus" width="24" height="24" style={{ marginTop: "-8px" }} />
        <FormLabel label="Invite Collaborators" />
      </div>
      <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "center" }}>
        <FormInput type="email" placeholder={updatedEvent?.public_id ? "email@example.com" : "Save event to invite collaborators"} value={inviteEmail}
          ref={emailRef}
          disabled={!updatedEvent?.public_id}
          onChange={(e) => {
            setInviteEmail(e.target.value);
            // clear the input field if the email is valid and the user presses enter
          }}
        />
        <Button
          disabled={!updatedEvent?.public_id || !validEmail || sendingInvite}
          title={!updatedEvent?.public_id ? "Save the event to enable inviting collaborators" : !validEmail ? "Enter a valid email address" : ""}
          onClick={async () => {
            if (!updatedEvent?.public_id || !validEmail || sendingInvite) {
              return;
            }
            setSendingInvite(true);
            const results = await inviteCollaborator(token, updatedEvent?.public_id, inviteEmail);
            console.log("!!! INVITE RESULTS: ", results);
            if (results.success) {
              setInviteEmail("");
              const ue = { ...updatedEvent };
              ue.collaborators = [...(ue.collaborators ?? []), results.collaborator];
              setUpdatedEvent(ue);
            }
            emailRef.current.value = "";
            setSendingInvite(false);
          }}
        >{sendingInvite ? "Sending" : "Send Invite"}</Button>
      </div>
      <div>
        {
          updatedEvent?.collaborators?.sort((a, b) => {
            if (a.role === "host" && b.role !== "host") return -1;
            if (a.role !== "host" && b.role === "host") return 1;
            return a.id - b.id;
          }).map((collaborator) => (
            <div style={{ marginTop: "10px" }} key={collaborator.id}>
              <CollaboratorCard collaborator={collaborator} allowChangeRole={allowChangeRole} />
            </div>
          ))
        }
      </div>
      <div>
      </div>
      <div style={{
        display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", marginTop: "20px"
      }} >
        <Icon icon="mdi:account-multiple" width="24" height="24" style={{ marginTop: "-8px" }} />
        <FormLabel label={
          <div>Event Participants <MetaInfo>{userCount} participants</MetaInfo></div>
        } />
      </div>
      <div>
        {
          updatedEvent?.users?.filter((a) => {
            console.log("!!! CHECKING USER: ", a);
            return updatedEvent?.collaborators?.find((collaborator) => collaborator.user_id === a.id) ? false : true;
          }).sort((a, b) => {
            return a.id - b.id;
          }).slice(0, 6).map((user) => (
            <ParticipantCard key={user.id} participant={user} />
          ))
        }
        <ParticipantCard key="remaining" remainingCount={userCount - 6} />
      </div>
    </div>
  );
};

export default PreviewSidebar;
